// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__L8DKy","bigColWidth":"Table_bigColWidth__2PaC8","biggerColWidth":"Table_biggerColWidth__1MqlB","row":"Table_row__2rru3","col":"Table_col__3HZ6G"};